import { defineMessages } from 'react-intl';

// messages are defined using snake case, because they have to match
// error codes sent from backend
export const warningTranslations = defineMessages({
  boolean_column_invalid: {
    defaultMessage: 'column is type: boolean. Valid values are true or false.',
    id: 'HbJo8S',
    description: 'Boolean value invalid error message',
  },
  enumeration_column_invalid: {
    defaultMessage: 'column is type: enumeration. Valid values are {constraintValue}.',
    id: 'UIfb5h',
    description: 'Enumeration value invalid error message',
  },
  string_column_truncated: {
    defaultMessage: 'column truncated because it exceeded the maximum number of characters: {constraintValue}.',
    id: '6tFtD+',
    description: 'String value truncated error message',
  },
  decimal_column_invalid: {
    defaultMessage: 'column requires a decimal value.',
    id: 'KA2Mk4',
    description: 'Decimal value invalid error message',
  },
  integer_column_invalid: {
    defaultMessage: 'column requires a numeric value.',
    id: 'qMsAxx',
    description: 'Integer value invalid error message',
  },
  number_column_over_max_value: {
    defaultMessage: 'column value exceeded the maximum number allowed: {constraintValue}.',
    id: 'djaJAD',
    description: 'Number value over max value error message',
  },
  number_column_under_min_value: {
    defaultMessage: 'column value is less than the minimum number allowed: {constraintValue}.',
    id: 'r2XGfF',
    description: 'Number value under min value error message',
  },
  inactive_product: {
    defaultMessage: 'Skipping record because this product is marked inactive.',
    id: 'whDat7',
    description: 'Inactive product error message',
  },
  matching_parent_product: {
    defaultMessage: 'Skipped record. This matched the parent record of a product with variants.',
    id: 'aGQN4y',
    description: 'Matching parent product error message',
  },
  alias_matching_restrictions: {
    defaultMessage: 'Skipped record. Matched a product alias.',
    id: 'k+ND61',
    description: 'Alias match restrictions error message',
  },
  missing_product_lot_id: {
    defaultMessage: 'Product Lot ID is missing. The field must be non empty when ExpirationDate is set.',
    id: 'lgKq+J',
    description: 'Missing product lot ID error message',
  },
  date_time_column_invalid: {
    defaultMessage: 'column is type: date. Suggested date format: mm/dd/yy.',
    id: 'lJ3EgJ',
    description: 'Date value invalid error message',
  },
  supplier_missing_seller_sku: {
    defaultMessage: 'Product SKU is missing. The field is required to associate the product with a supplier.',
    id: 'KIl2mO',
    description: 'Missing product SKU error message',
  },
  uom_type_each_skipped: {
    defaultMessage: "Rows with UOM type 'Each' are skipped — 'Each' is represented by the product itself.",
    id: 'JoDCEg',
    description: 'Each UOM type skipped warning message',
  },
});

export const errorTranslations = defineMessages({
  required_column_empty: {
    defaultMessage: 'column is required.',
    id: 'VlQGB6',
    description: 'Required column empty error message',
  },
  decimal_column_invalid: {
    defaultMessage: 'column is required. Column requires a decimal value.',
    id: '1v+7cD',
    description: 'Required decimal value invalid error message',
  },
  integer_column_invalid: {
    defaultMessage: 'column is required. Column requires a numeric value.',
    id: '4VkgeR',
    description: 'Required integer value invalid error message',
  },
  number_column_over_max_value: {
    defaultMessage: 'column is required, but column value exceeded the maximum number allowed: {constraintValue}.',
    id: '0j3Skw',
    description: 'Required number value over max value error message',
  },
  number_column_under_min_value: {
    defaultMessage: 'column is required, but column value is less than the minimum number allowed: {constraintValue}.',
    id: 'OoX15c',
    description: 'Required number value under min value error message',
  },
  db_error: {
    defaultMessage: 'Unable to save record. If this error persists, please contact support.',
    id: 'A7LFXc',
    description: 'Database import error message',
  },
  not_enough_stock: {
    defaultMessage: 'Not enough items in stock to continue saving this record.',
    id: '7Y/LjQ',
    description: 'Not enough stock error message',
  },
  missing_product_name: {
    defaultMessage: 'Product Name is missing. The field must be a valid text entry. Empty values are not allowed.',
    id: 'sbkDDZ',
    description: 'Missing product name error message',
  },
  date_time_column_invalid: {
    defaultMessage: 'column is required. Column requires a date value. Suggested date format: mm/dd/yy.',
    id: 'niCyB1',
    description: 'Required date value invalid error message',
  },
  invalid_parent_sku: {
    defaultMessage:
      'and SKU cannot be the same value. If this row represents a Parent product, leave the Parent SKU field blank. If this row represents a Variant product, specify a different SKU as the Parent SKU.',
    id: 'p6/wTA',
    description: 'invalid parent sku error message',
  },
});
